import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, Paper } from '@material-ui/core'
import { useDispatch, useSelector } from "react-redux";
import { setMovePaxDeps, loadMovePaxDeps, saveMovePaxChanges, resetMessageStatus, resetMovePaxList } from "../../../store/dcs";
import { SelectWithLabel } from "../../../utils/selectWithLabel";
import { ExitButton } from "../../../utils/etc";
import { formatPaxName } from "./modalFunctions";
import StatusDisplay from "../../admin/StatusDisplay";
import _ from 'lodash';
import axios from 'axios';
import {Typography} from '@material-ui/core';

const groupPaxByRloc = (paxArr) => {
  let rlocPax = []

  for (let i = 0; i < paxArr.length; i++) {
    const pax = paxArr[i];
    let rlocPaxLoc = rlocPax.findIndex(item => item.rloc === pax.PNRRefNo)
    if (rlocPaxLoc !== -1) {
      rlocPax[rlocPaxLoc].passengers.push(pax)
    }
    else {
      rlocPax.push({rloc: pax.PNRRefNo, passengers: [pax]})
    }
  }

  return rlocPax
}

const getGroupColor = (group, selectedPax, ogFltNo, isText) => {
  // NOTE // if the first passenger in the group isn't from the original flight, it is not an option
  if (group.passengers[0].FLTNO !== ogFltNo) {
    return isText ? 'black' : '#b1b1b1'
  }
  // NOTE // anything else is an option
  else {
    // NOTE // if the groups rloc is the same as selectedPax, it is selected
    if (group.rloc === selectedPax) {
      return isText ? 'white' : '#4545ff'
    }
    // NOTE // if it's a non-selected option, stick to the default
    else {
      return ''
    }
  }
}

const isKalsoft = (paxGroup) => {
  let output = paxGroup.passengers.filter((pax) => pax.Kal === '1').length > 0
  return output
}

// NOTE // used to display the pax choices
const FlightPaxDisplay = (props) => {
  const selectedPax = props.selectedPax
  const setPax = props.setPax
  const originalFlightNum = props.originalFlight
  const groupedPax = props.pax

  return (
    <div style={{border: '2px solid black', marginLeft: '8px', width: '95%'}}>
      {groupedPax.map((group, index) => {
        let kalsoftGroup = isKalsoft(group)

        return (
          <div
            onClick={() => {
              if (group.passengers[0].FLTNO === originalFlightNum && !kalsoftGroup) {
                setPax(group.rloc)
              }
            }}
            style={{
              paddingLeft: '5px',
              cursor: 'pointer',
              backgroundColor: kalsoftGroup ? '#bfbcbc' : `${getGroupColor(group, selectedPax, originalFlightNum)}`,
              color: `${getGroupColor(group, selectedPax, originalFlightNum, true)}`
            }}
          >
            {group.passengers.map((pax, index) => {
              let rloc = group.rloc
              let paxName = formatPaxName(pax)
              return (
                <span>{rloc + ' ' + paxName} {index !== group.passengers.length ? <br/> : ''}</span>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

const displayDate = (date) => {
  // NOTE // input: 2021-10-11, output: 10-11-2021
  let month = date.slice(5, 7)
  let day = date.slice(8)
  let year = date.slice(0, 4)
  return month + '-' + day + '-' + year
}

const formatFlightDate = (date) => {
  // NOTE // output: 17AUG2021, input: 2021-08-17
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}

// NOTE // takes in the flights used to find matching flights, the original flight for comparison, the original's flight date, and the choices flight date (date format )
const getFlightChoices = (flights, flight, flightsDate, flightDate) => {
  let filteredFltChoices = []

  // NOTE // loop over flights and get usable choices
  if (flights && Array.isArray(flights) && flight) {
    for (let i = 0; i < flights.length; i++) {
      const flightChoice = flights[i];
      let sameDest = flightChoice.Destination === flight.Destination
      let sameOrigin = flightChoice.Origin === flight.Origin
      let sameFltNum = flightChoice.FlightNumber === flight.FlightNumber
      let sameDate = flightsDate === flightDate
      let sameDepTime = flight.Departure === flightChoice.Departure
      let isCancelled = flightChoice.NOPAX === "1"
      // NOTE // should only be able to move pax to a flight with same origin & destination
      if (sameDest && sameOrigin && !isCancelled) {
        // NOTE // Don't want to have the current flight as a choice
        if (sameFltNum && sameDate && sameDepTime) {
          continue
        }
        else {
          filteredFltChoices.push(flightChoice)
        }
      }
    }

    // NOTE // map over the filtered flight choices and format them for the SelectWithLabel component
    return filteredFltChoices.map(flt => {
      return { label: `${flt.FlightNumber} @ ${flt.Departure}`, value: flt }
    })
  }
  else {
    return []
  }
}

const MovePaxModal = (props) => {
  const modalClasses = props.modalClasses
  const dispatch = useDispatch()
  const flight = props.flight
  const closeModal = props.closeModal
  const movePaxChange=props.changeMovePaxStatus;
  const depDate = useSelector(state => state.entities.dcs.departureDate)
  const flights = useSelector(state => state.entities.dcs.list)
  const movePaxStatus = useSelector(state => state.entities.dcs.movePaxStatus)
  const airlineId=useSelector(state => state.entities.dcs.airline)
  // NOTE // the flights to pull from for move pax (choices to move to)
  const mpFlights = useSelector(state => state.entities.dcs.movePaxList)
  const requestingDeps = useSelector(state => state.entities.dcs.messageStatus)
  // NOTE // format for input: YYYY-MM-DD, format for req: DDMMMYYYY
  const [mpDepDate, setMpDepDate] = useState(depDate)
  // NOTE // the flight selected to move passengers to
  const [newFlight, setNewFlight] = useState('')
  // NOTE // the original flight's passengers, modified to show changes
  const [flightPax, setFlightPax] = useState(flight.passengers)
  // NOTE // the selected flight's passengers, modified to show changes
  const [newFlightPax, setNewFlightPax] = useState([])
  // NOTE // the selected rloc/pax, used for moving/removing pax from the boxes
  const [selectedPaxRloc, setSelectedPax] = useState('')
  const [getMovePaxStatus, setMovePaxStatus] = useState(null);
  const[getStatusText,setStatusText]=useState(null);
  useEffect(() => {
    dispatch(setMovePaxDeps(flights))
    dispatch(resetMessageStatus())
  }, []);

  const resetAllPax = (data) => {
    setFlightPax(flight.passengers)
    setNewFlightPax(data?.passengers ? data.passengers : [])
    setSelectedPax('')
  }

  //For the State management useState()
  const movePaxStatusController=(data)=>{
    if(data==="Loading")
    {
      setMovePaxStatus("Loading");
      movePaxChange("Loading");
    }
    if(data==="Success")
    {
      setMovePaxStatus("Success");
      movePaxChange("Success");
    }
    if(data==="Failed")
    {
      setMovePaxStatus("Failed");
      movePaxChange("Failed");
    }
  };

  const handleNewFlight = (data) => {
    // NOTE // set the new flight that passengers can be moved to
    setNewFlight(data)
    resetAllPax(data)
  }

  const handleFlightDate = (event) => {
    setMpDepDate(event.target.value)
    resetAllPax()
    dispatch(resetMovePaxList())
    dispatch(loadMovePaxDeps(formatFlightDate(event.target.value)))
  }

  // NOTE // function that moves passengers between flights. If toNew is true it moves from original to the new flight, else it moves from the new flight to the original
  const movePaxToFlight = (toNew) => {
    // NOTE // get the passengers with the selected rloc
    let paxArr = toNew ? flightPax.filter(p => p.PNRRefNo === selectedPaxRloc) : newFlightPax.filter(p => p.PNRRefNo === selectedPaxRloc)

    // NOTE // if there is a selected rloc, passengers with that rloc, and a selected new flight
    if (selectedPaxRloc && paxArr.length > 0 && newFlight) {
      // NOTE // making copies of flightPax/newFlightPax so that we can change them
      let flightPaxCopy = _.cloneDeep(flightPax)
      let newFlightPaxCopy = _.cloneDeep(newFlightPax)

      // NOTE // looping over the selected pax
      for (let i = 0; i < paxArr.length; i++) {
        const pax = paxArr[i];
        // NOTE // get the location of the selected pax
        let paxLoc;
        if (toNew) {
          paxLoc = flightPaxCopy.findIndex(p => p.PNRRefNo === pax.PNRRefNo && p.PaxNumber === pax.PaxNumber)
        }
        else {
          paxLoc = newFlightPaxCopy.findIndex(p => p.PNRRefNo === pax.PNRRefNo && p.PaxNumber === pax.PaxNumber)
        }

        if (paxLoc !== -1) {
          // NOTE // remove the selected pax from the original pax OR new flight pax
          toNew ? flightPaxCopy.splice(paxLoc, 1) : newFlightPaxCopy.splice(paxLoc, 1)
          // NOTE // add the selected pax to the new flight pax OR the original pax
          toNew ? newFlightPaxCopy.push(pax) : flightPaxCopy.push(pax)
        }
      }

      // NOTE // set the original and newFlightPax. Reset selectedPax
      setFlightPax(flightPaxCopy)
      setNewFlightPax(newFlightPaxCopy)
      setSelectedPax('')
    }
  }

  const saveChanges = async () => {
    // NOTE // (date formats) depDate: 2021-10-15, mpDepDate: 2021-10-16, formatFlightDate: 17AUG2021
    try {
      // NOTE // will only work if a new flight is selected, and passengers have been moved
      if (newFlight && flightPax.length !== flight.passengers.length) {
        console.log(`Moving pax to new flight :: ${flight.FlightNumber}`);
        let rlocs = []
        let from = `${flight.FlightNumber}/${formatFlightDate(depDate).slice(0, 5)}`
        let to = `${newFlight.FlightNumber}/${formatFlightDate(mpDepDate).slice(0, 5) + formatFlightDate(mpDepDate).slice(7)}/${newFlight.Origin}/${newFlight.Destination}`
        console.log(`from :: ${from} - to :: ${to}`);
        // NOTE // get the changed passengers by getting the pax that aren't from the newFlight
        let newFlightPaxCopy = _.cloneDeep(newFlightPax)
        // NOTE // loop over the changed pax and add their rlocs to the rlocs array
        for (let i = 0; i < newFlightPaxCopy.length; i++) {
          let newPax = newFlightPaxCopy[i]
          let originalPaxLoc = flight.passengers.findIndex(pax => pax.PNRRefNo === newPax.PNRRefNo)
          if (originalPaxLoc !== -1) {
            rlocs.push(newFlightPaxCopy[i].PNRRefNo)
          }
        }
        console.log(`rlocs :: ${rlocs}`);
        // NOTE // example: dispatch(saveMovePaxChanges(['AAAAJB'], 'TJ1006/22Oct', 'TJ1004/22Oct21/HPN/ACK'))
        movePaxStatusController("Loading");
        postCallMovePax(_.uniq(rlocs), from, to, airlineId);
        // dispatch(saveMovePaxChanges(_.uniq(rlocs), from, to))
      }
    } catch (err) {
      console.error("saveChanges err: ", err);
    }
  };

  // const payload = {airlineId: req.body.airlineId, rlocs: req.body.rlocs, from: req.body.from, to: req.body.to}
  const postCallMovePax = async (rlocs, from, to, airlineId) => {
    // const url = `movePax`
    // NOTE // backend expects
    // from: from, // TJ1002/25Aug
    // to: to, // TJ1000/25AUG21/HPN/ACK

   //Removed from redux and added Api call
   
    //  return( dispatch(apiCallBegan({
    //     url,
    //     method: 'post',
    //     data: {airlineId:airlineId, rlocs: rlocs, from: from, to: to}
    //   })));
    // console.log(process.env.REACT_APP_APIURL);

    //Payload for the Api Call
    const payload = {
      airline_id: airlineId,
      rlocs: rlocs,
      from: from,
      to: to,
    };
    console.log(payload);
    const token = localStorage.getItem("x-auth-token");

    //Taking Token from Local Storage
    const reqHeaders = {
      headers: { "x-auth-token": token },
    };

    //Using Axios for Calling Api
    try {
      axios
        .post(`${process.env.REACT_APP_APIURL}/api/movePax`,payload, reqHeaders)
        .then((res) => {
          console.log(res);
          if(res.data===null||undefined)
          {
            movePaxStatusController("Failed");
            setStatusText("Something went wrong Please Refresh and Try Again");
            return;
          }
          let result = res.data.every((movePax) => {
            return movePax.error === null && movePax.result === "ok";
          });
          if (result === true) {
            movePaxStatusController("Success");
            setStatusText("All the Pnrs were moved Successfully");
          }
          if (result === false) {
            let status = res.data
              .map((movePax) => {
                let res =
                  movePax.error === null && movePax.result === "ok"
                    ? "Success"
                    : "Failed";
                return movePax.rloc + " = " + res;
              });
           status=status.toString().replaceAll(","," , ");
            movePaxStatusController("Failed");
            setStatusText("Failed To Move All the pnrs "+status);

          }
        }).catch(error=> {
         console.log(error);
          console.log("Exception while moving pnrs");
      movePaxStatusController("Failed");
      setStatusText("Something went wrong Please Refresh and Try Again");
        })
       ;
    } catch (error) {
      console.log(error);
      console.log("Exception while moving pnrs");
      movePaxStatusController("Failed");
      setStatusText("Something went wrong Please Refresh and Try Again");

    }
  };
  // NOTE // getting all same-day flights that have the same origin and destination
  const flightChoices = getFlightChoices(mpFlights, flight, mpDepDate, depDate)

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      <Paper className={modalClasses.paper}>
        <Grid id="modal-header" container item xs={12} justify="center" className={modalClasses.modalHeader}>
          <Grid item xs={2} lg={3}></Grid>
          <Grid container justifyContent="center" item xs={7} lg={6}>
            <h5 style={{margin: "0px", paddingTop: "12px"}}>
              {flight.FlightNumber + " Move Pax "}
            </h5>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid container alignContent="flex-start" justifyContent="flex-end" style={{paddingRight: '8px'}} item xs={2}>
            <ExitButton exit={closeModal} />
          </Grid>
        </Grid>
        <Grid id="cur-flight-info" container justifyContent="center" item xs={12}>
          <Grid container justifyContent="center" item lg={3} xs={12}>
            <b>Flight Number</b>:{flight.FlightNumber}
          </Grid>
          <Grid container justifyContent="center" item lg={3} xs={12}>
            <b>Dep. Date</b>:{displayDate(depDate)}
          </Grid>
          <Grid container justifyContent="center" item lg={3} xs={12}>
            <b>Origin-Destination</b>:{flight.Origin + '-' + flight.Destination}
          </Grid>
        </Grid>
        <Grid id="date-and-flight-selector" container item xs={12} style={{marginTop: '8px', marginBottom: '8px'}}>
          {/* NOTE // want users to be able to pick a date range when looking for matching flights */}
          <Grid item xs={1} lg={3}></Grid>
          <Grid container justifyContent="flex-start" item xs={5} lg={3}>
            <TextField
              id="depDate"
              label="Departure Date"
              type="date"
              defaultValue={mpDepDate}
              className={modalClasses.textField}
              InputLabelProps={{ shrink: true }}
              onChange={handleFlightDate}
            />
          </Grid>
          <Grid container justifyContent="flex-end" item xs={5} lg={3}>
            {
              requestingDeps ? 
              <Grid container justifyContent="flex-start" alignContent="flex-end" style={{fontSize: 'x-large', paddingLeft: '10px'}}>Loading...</Grid> :
              <SelectWithLabel defaultVal={newFlight} handleChange={(e) => {handleNewFlight(e.target.value)}} inputLabel={'Flights'} items={requestingDeps ? [] : flightChoices} />
            }
          </Grid>
          <Grid item xs={1} lg={3}></Grid>
        </Grid>
        <Grid id="passenger-select" container item xs={12} style={{minHeight: '200px'}}>
          <Grid container item xs={6}>
            <FlightPaxDisplay pax={groupPaxByRloc(flightPax)} selectedPax={selectedPaxRloc} setPax={setSelectedPax} originalFlight={flight.FlightNumber} />
          </Grid>
          <Grid container item xs={6}>
            <FlightPaxDisplay pax={groupPaxByRloc(newFlightPax)} selectedPax={selectedPaxRloc} setPax={setSelectedPax} originalFlight={flight.FlightNumber} />
          </Grid>
        </Grid>
        <Grid id="passenger-controls" container justifyContent="center" item xs={12} style={{marginTop: '8px'}}>
          <Grid container justifyContent="center" item xs={4} lg={2}>
            <Button size="small" className={modalClasses.movePaxButton} disabled={selectedPaxRloc && newFlight ? false : true} variant="contained" onClick={() => {movePaxToFlight(true)}}>Move</Button>
          </Grid>
          <Grid container justifyContent="center" item xs={4} lg={2}>
            <Button size="small" className={modalClasses.movePaxButton} disabled={selectedPaxRloc && newFlight ? false : true} variant="contained" onClick={() => {movePaxToFlight(false)}}>Remove</Button>
          </Grid>
          <Grid container justifyContent="center" item xs={4} lg={2}>
            <Button size="small" className={modalClasses.movePaxButton} variant="contained" onClick={() => {resetAllPax(newFlight)}}>Reset Pax</Button>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="space-around"
          item
          xs={11}
          style={{ marginTop: "16px", marginBottom: "8px" }}
        >
        <Typography style={{paddingLeft:"20px"}}>
          {getMovePaxStatus!==null?getStatusText:null}
        </Typography>
        <Grid
          id="buttons"
          container
          justifyContent="flex-end"
          alignContent="center"
          item
          xs={11}
          style={{ marginTop: "16px", marginBottom: "8px" }}
        >
          <Button
            onClick={() => {
              closeModal();
            }}
            variant="contained"
            size="small"
            style={{ backgroundColor: "#eb494e", marginRight: "8px" }}
          >
            close
          </Button>
          {getMovePaxStatus === null ? (
            <Button
              onClick={() => {
                saveChanges();
              }}
              variant="contained"
              size="small"
              style={{ backgroundColor: "#03fc66" }}
              disabled={newFlightPax.length < 1}
            >
              save changes
            </Button>
          ) :(<Typography style={{marginTop:"3px",marginLeft:"20px",color:getMovePaxStatus==="Success"?'green':'black'}}>
            {getMovePaxStatus}
            </Typography>
          )}
                  </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default MovePaxModal